import styled from "@emotion/styled";

export const Container = styled.div`
  display: flex;
  width: 100%;
  height: 75px;
  padding: 12px 24px;
  align-items: center;
  gap: 20px;

  border-bottom: 1px solid var(--alias-color-line-normal);
  box-sizing: border-box;
`;

export const InfoContainer = styled.div`
  display: flex;
  min-width: 280px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 4px;
  flex: 1 0 0;
`;

export const BtnContainer = styled.div`
  display: flex;
  width: 237px;
  height: 32px;
  align-items: center;
  gap: 8px;
`;
